module.exports = __webpack_public_path__ + "static/media/MenuChocolateRasp.fa152075.jpg";